(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[372],{

/***/ 5105:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tool/simba",
      function () {
        return __webpack_require__(7624);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LayoutTool */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var next_head_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4058);
/* harmony import */ var _providers_ConfigContextProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5547);
/* harmony import */ var _app_Menu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(240);
/* harmony import */ var _app_MatomoUserTracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7051);
/* harmony import */ var _styled_LoadingBar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4321);
/* harmony import */ var _app_MenuButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3063);
/* harmony import */ var _tools_shared_Sidebar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9814);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9521);
/* harmony import */ var _state_PageState__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5707);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  top: 0;\n  left: 0;\n  width: 100%;\n  min-height: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n\n  ",
        " {\n    padding-left: var(--size-6);\n  }\n\n  *::selection {\n    background: #fff !important;\n    color: #000 !important;\n  }\n\n  .column.about p a,\n  .column.about .cta p a,\n  .column.details p a {\n    text-decoration: underline dotted 0.5px;\n    text-decoration-color: inherit;\n    text-underline-offset: 3px;\n    transition: all ease-out 0.5s;\n\n    &:hover{\n      text-decoration: underline solid 2px;\n      text-underline-offset: 2px;\n      margin-right: 0;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var ToolContainer = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-977fef09-0"
})(_templateObject());
var ContentContainer = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-977fef09-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var LayoutTool = function(param) {
    var children = param.children, props = param.props;
    var config = (0,_providers_ConfigContextProvider__WEBPACK_IMPORTED_MODULE_3__/* .useConfigContext */ .q)();
    var isLoading = (0,_state_PageState__WEBPACK_IMPORTED_MODULE_9__/* .usePageStateIsLoadingState */ .YB)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_head_seo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: "".concat(config.appTitle),
                og: {
                    image: "".concat(config.baseUrl, "/img/poster.jpg"),
                    type: "article",
                    siteName: "".concat(config.appTitle)
                },
                twitter: {
                    card: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_MatomoUserTracking__WEBPACK_IMPORTED_MODULE_5__/* .MatomoUserTracking */ .b, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_styled_LoadingBar__WEBPACK_IMPORTED_MODULE_6__/* .LoadingBar */ .F, {
                isLoading: isLoading
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_MenuButton__WEBPACK_IMPORTED_MODULE_7__/* .MenuButton */ .j, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ToolContainer, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_tools_shared_Sidebar__WEBPACK_IMPORTED_MODULE_8__/* .Sidebar */ .Y, {
                        tool: props.tool.slug
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ContentContainer, {
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_Menu__WEBPACK_IMPORTED_MODULE_4__/* .Menu */ .v, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LayoutTool);


/***/ }),

/***/ 7624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ simba; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next-head-seo/dist/index.module.js
var index_module = __webpack_require__(4058);
// EXTERNAL MODULE: ./config/index.ts + 1 modules
var config = __webpack_require__(5740);
// EXTERNAL MODULE: ./components/layouts/LayoutTool.tsx
var LayoutTool = __webpack_require__(7416);
// EXTERNAL MODULE: ./components/ui/LabElement.tsx
var LabElement = __webpack_require__(7656);
// EXTERNAL MODULE: ./components/tools/shared/ui/Icon.tsx
var Icon = __webpack_require__(7205);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./components/tools/shared/ui/Box.tsx
var Box = __webpack_require__(8695);
// EXTERNAL MODULE: ./components/styled/Button.tsx
var Button = __webpack_require__(5301);
// EXTERNAL MODULE: ./components/tools/shared/ToolSvgBackground.tsx + 40 modules
var ToolSvgBackground = __webpack_require__(7626);
// EXTERNAL MODULE: ./components/state/CssVarsState.tsx
var CssVarsState = __webpack_require__(9479);
;// CONCATENATED MODULE: ./components/tools/simba/simbaInput.tsx

var preGeneratedText = [
    {
        example: "Newspaper article",
        text: "<p>Am Mittwoch streiken in Berlin viele Besch\xe4ftigte des \xf6ffentlichen Dienstes. Das bedeutet: Sie arbeiten nicht. Denn sie fordern mehr Lohn. Das sind 10,5 Prozent mehr als bisher.  Die Besch\xe4ftigten des \xf6ffentlichen Dienstes arbeiten in Schulen, Kitas und B\xfcrger\xe4mtern. Sie arbeiten auch in der Polizei und bei der Feuerwehr.  Die Gewerkschaften haben die Besch\xe4ftigten zum Streik aufgerufen. Gewerkschaften sind Organisationen, in denen sich Arbeitnehmer zusammenschlie\xdfen. Sie vertreten die Interessen der Arbeitnehmer.  Die Gewerkschaften wollen, dass die Besch\xe4ftigten mehr Lohn bekommen.</p>\n    "
    },
    {
        example: "Wikipedia page",
        text: "<p>Eine Suchmaschine ist ein Programm, mit dem man im Internet nach Dokumenten suchen kann. Man gibt einen Suchbegriff ein und die Suchmaschine zeigt dann eine Liste von Dokumenten an, die zu diesem Suchbegriff passen. Dabei verwendet die Suchmaschine verschiedene Suchverfahren. Die Suchmaschine erstellt und pflegt einen Index. Das ist eine Datenstruktur, in der Informationen \xfcber Dokumente gespeichert sind. Die Suchmaschine verarbeitet auch Suchanfragen. Das bedeutet, dass sie nach Dokumenten sucht, die zu einem bestimmten Suchbegriff passen. Die Suchmaschine bereitet die Ergebnisse dann so auf, dass sie f\xfcr den Benutzer leicht verst\xe4ndlich sind.</p>"
    },
    {
        example: "App description",
        text: "<p>2011 wurde die App MapsWithMe erstellt. Die App wurde in Organic Maps umbenannt. Die App ist kostenlos und kann auf Android und iOS Ger\xe4ten verwendet werden. Die App basiert auf den Daten von OpenStreetMap. Mit der App kann man sich auf der Karte orientieren. Man kann auch Karten herunterladen und offline verwenden. Die App ist sehr datenschutzfreundlich.</p>"
    }, 
];
var input = [
    {
        example: "Newspaper article",
        text: "   \n    <p><strong>Schulen, Kitas, B\xfcrger\xe4mter: Am Mittwoch d\xfcrften viele Berlinerinnen und Berliner Einschr\xe4nkungen bemerken - wegen eines Warnstreiks der Besch\xe4ftigten des \xf6ffentlichen Dienstes. Gewerkschaften fordern 10,5 Prozent mehr Lohn.</strong></p>\n    \n    <p>Notbetreuung in Schulen, geschlossene Kitas, eingeschr\xe4nkte Besetzung der B\xfcrger\xe4mter: Am Mittwoch hat ein Warnstreik der Berliner Besch\xe4ftigten, die unter den Tarifvertrag der L\xe4nder fallen, begonnen. Es sei mit Unterrichtsausfall an zahlreichen Schulen zu rechnen, sagte ein Sprecher der beteiligten Gewerkschaft Erziehung und Wissenschaft (GEW) am Morgen. Mindestens 100 Kitas blieben geschlossen, sagte ein Verdi-Sprecher dem rbb.</p>\n\n    <p>Zum Warnstreik aufgerufen sind die Besch\xe4ftigten der Senatsverwaltungen und Bezirks\xe4mter, die Schulen und Hochschulen, die Polizeidienststellen, die Feuerwehr, die Kitas und die forstwirtschaftlichen Betriebe des Landes Berlin, wie die Gewerkschaften Verdi, Erziehung und Wissenschaft (GEW), der Polizei (GdP) und IG Bau gemeinsam mitteilten.</p>\n    \n    <p>Begleitet wird der Streik in Berlin von einer Demo am Vormittag. Sie beginnt am Wittenbergplatz und zieht dann bis zum Platz des 18. M\xe4rz. Die Organisatoren rechnen eigenen Angaben zufolge mit Tausenden Teilnehmern. Auch in den anderen Stadtstaaten Bremen und Hamburg sind die Besch\xe4ftigten des \xf6ffentlichen Diensts zu Arbeitsniederlegungen aufgerufen.</p>"
    },
    {
        example: "Wikipedia page",
        text: "\n    <p>Eine Suchmaschine ist ein Programm zur Recherche von Dokumenten, die in einem Computer oder einem Computernetzwerk wie z. B. dem World Wide Web gespeichert sind. Nach Erstellung einer Suchanfrage, oftmals durch Texteingabe eines Suchbegriffs, liefert eine Suchmaschine eine Liste von Verweisen auf m\xf6glicherweise relevante Dokumente, meistens dargestellt mit Titel und einem kurzen Auszug des jeweiligen Dokuments. Dabei werden verschiedene Suchverfahren verwendet.</p>\n\n    <p>Die wesentlichen Bestandteile bzw. Aufgabenbereiche einer Suchmaschine sind:</p>\n    \n    <ul>\n      <li>Erstellung und Pflege eines Index (Datenstruktur mit Informationen \xfcber Dokumente),</li>\n      <li>Verarbeiten von Suchanfragen (Finden und Ordnen von Ergebnissen) sowie</li>\n      <li>Aufbereitung der Ergebnisse in einer m\xf6glichst sinnvollen Form.</li>\n    </ul>\n    \n    <p>In der Regel erfolgt die Datenbeschaffung automatisch, im Internet durch Webcrawler, auf einem einzelnen Computer durch regelm\xe4\xdfiges Einlesen aller Dateien in vom Benutzer spezifizierten Verzeichnissen im lokalen Dateisystem.</p>\n    "
    },
    {
        example: "App description",
        text: "<p>Organic Maps ist eine freie und kostenlose Offline-Karten-App f\xfcr Android und iOS f\xfcr Reisende, Touristen, Wanderer und Radfahrer, die auf den Daten von OpenStreetMap basiert. Es handelt sich um eine datenschutzfreundliche, quelloffene Abspaltung der Maps.me-App (fr\xfcher bekannt als MapsWithMe), die von denselben Leuten gepflegt wird, die MapsWithMe im Jahr 2011 erstellt haben.</p>\n\n    <p>Organic Maps ist heutzutage eine der wenigen Apps, die 100% ihrer Funktionen ohne aktive Internetverbindung unterst\xfctzt. Installiere Organic Maps, lade Karten herunter, wirf deine SIM-Karte weg (dein Betreiber verfolgt dich \xfcbrigens st\xe4ndig) und mache einen Wochenausflug mit einer einzigen Akkuladung, ohne dass ein Byte an das Netz gesendet wird.\n    </p>"
    }, 
];

;// CONCATENATED MODULE: ./pages/tool/simba/index.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-3);\n  padding: var(--size-3);\n\n  h1,\n  h2,\n  h3 {\n    ",
        ';\n  }\n\n  h1 {\n    line-height: 1em;\n  }\n\n  h2 {\n    font-size: var(--text-body-font-size-tool) * 1.1;\n    font-weight: bold;\n    margin-top: 0 !important;\n  }\n\n  h3 {\n    font-size: 12px;\n    font-weight: 300;\n    line-height: 1em;\n    // margin: var(--size-4) 0 calc(0px - var(--size-3));\n  }\n\n  ul li::marker {\n    content: "— ";\n    position: absolute;\n  }\n\n  textarea {\n    background: transparent;\n    boder: 1px solid white;\n    color: white;\n    font-size: 0.8em;\n    padding: var(--size-2);\n    border-radius: var(--size-1);\n    height: fit-content;\n    min-height: 10em;\n    width: 100%;\n  }\n\n  // .hightlight {\n  //   background: ',
        ";\n  //   text-shadow: 0px 1px 3px black;\n  // }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  display: grid;\n  gap: var(--size-3);\n  grid-template-areas:\n    "about"\n    "ff"\n    "chrome"\n    "test";\n\n  // ',
        ' {\n  //   grid-template-areas:\n  //     "gpu other other other"\n  //     "script script stats1 stats1 stats1"\n  //     "script script stats2 stats2 stats2";\n  // }\n\n  ',
        ' {\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-template-areas:\n      "about about ff"\n      " about about chrome"\n      " about about blank"\n      "test test test";\n  }\n\n  // ',
        ' {\n  //   grid-template-areas:\n  //     "gpu other other other other"\n  //     "script script stats1 stats1 stats1"\n  //     "script script stats2 stats2 stats2";\n  // }\n\n  & .download{\n    a{\n      align-self: start;\n      margin-left: 0;\n\n      &:hover{\n        margin-left: -0.3em;\n      }\n    }\n\n    &.firefox {\n      grid-area: ff;\n    }\n\n    &.chrome {\n      grid-area: chrome;\n    }\n  }\n  \n\n  & .about {\n    grid-area: about;\n    display: grid;\n    grid-template-columns: 1fr;\n    grid-template-areas:\n      "title"\n      "copy"\n      "screenshot"\n      "subline";\n      \n    align-items: center;\n\n    ',
        ' {\n      grid-template-columns: 1fr 1fr;\n      grid-template-areas:\n        "title title"\n        "copy screenshot"\n        "subline subline";\n    }\n\n    ',
        ' {\n      grid-template-columns: 1fr 2fr;\n      grid-template-areas:\n        "title title"\n        "copy screenshot"\n        "subline subline";\n    }\n\n    ',
        ' {\n      grid-template-columns: 1fr 3fr;\n      grid-template-areas:\n        "title title"\n        "copy screenshot"\n        "subline screenshot";\n    }\n\n    .svg {\n      min-height: 50px;\n      // width: 100%;\n      // max-width: 270px;\n    }\n\n    .title{\n      grid-area: title;\n      background-position: left center !important;\n    }\n\n    .copy{\n      grid-area: copy;\n    }\n\n    .screenshot {\n      grid-area: screenshot;\n      min-height: calc(100vw / 1.4 - 80px);\n\n      ',
        ' {\n        min-height: 330px;\n      }\n    }\n\n    .subline{\n      grid-area: subline;\n    }\n  }\n\n  & .test {\n    grid-area: test;\n    display: grid;\n    gap: var(--size-4);\n    grid-template-columns: 1fr;\n    grid-template-areas:\n      "title"\n      "filter"\n      "input"\n      "output"\n      "footnote";\n\n    ',
        ' {\n      grid-template-columns: 1fr 1fr;\n      grid-template-areas:\n        "title title"\n        "filter filter"\n        "input output"\n        "footnote footnote";\n      }\n    }\n  }\n    .intro  { grid-area: title;   }\n    .input  { grid-area: input    }\n    .output { \n      grid-area: output;\n      font-family: var(--font-family-monospace);\n      font-size: 0.9em;\n    }\n\n    .footnote  { grid-area: footnote;   }\n\n  }\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-family: var(--font-family-narrow);\n  line-height: 18px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  color: #fff;\n  height: fit-content;\n  align-self: flex-start;\n  justify-content: flex-start;\n\n  ",
        '\n\n  grid-template-areas:\n    "icon ."\n    "icon .";\n\n  .svg {\n    grid-area: icon;\n    min-height: 3em;\n    min-width: 3em;\n    max-width: 3em;\n    flex: 1em 0 0;\n    margin-right: var(--size-3);\n\n    ',
        " {\n      margin-right: var(--size-2);\n    }\n  }\n\n  p,\n  h3 {\n    margin-bottom: 3px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // ul, li reset\n  padding: 0;\n  margin: 0;\n  & li {\n    margin: 0;\n    padding: 0;\n  }\n\n  display: grid;\n  gap: var(--size-1);\n  grid-template-columns: repeat(",
        ", 1fr);\n\n  ",
        " {\n    grid-template-columns: repeat(",
        ", 1fr);\n  }\n\n  ",
        "\n  letter-spacing: 0.02em;\n\n  .svg {\n    min-height: 0.8em !important;\n    min-width: 0.8em !important;\n    max-height: 0.8em;\n    max-width: 0.8em;\n    align-self: center;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: var(--size-2);\n\n  &.filter {\n    justify-content: start;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  padding: 3px var(--size-1);\n  gap: var(--size-1);\n  max-width: 100%;\n\n  ",
        "\n\n  background-color: ",
        ";\n  color: var(--color-piai-simba);\n  border: 1px solid var(--color-piai-simba);\n  border-radius: 4px;\n  cursor: ",
        ";\n\n  & .svg {\n    filter: invert(58%) sepia(83%) saturate(375%) hue-rotate(131deg)\n      brightness(111%) contrast(101%);\n    max-width: 10px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: var(--size-3);\n\n  margin-top: 100px;\n\n  ",
        " {\n    margin-top: unset;\n    margin-right: 100px;\n  }\n\n  h1 {\n    font-weight: bold;\n    margin-bottom: 0;\n    line-height: 1.1em;\n  }\n\n  p {\n    ",
        "\n    margin-bottom: 0;\n    margin-top: var(--size-1);\n  }\n\n  button,\n  li {\n    max-height: 1.5em;\n    margin-top: 13px;\n    font-size: calc(var(--text-body-font-size-tool) * 0.85);\n    line-height: 1em;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  p{\n    h1,\n  h2,\n  h3 {\n    text-transform: none;\n    font-weight: bold;\n    margin: 2em 0 1em;\n    \n    &:first-child{\n      margin-top: 0;\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  color: var(--color-piai-simba);\n  position: relative;\n  animation: loading 4s ease-in-out infinite;\n  transform-origin: left bottom;\n  padding-bottom: 0.3em;\n\n  &:after {\n    content: "";\n    width: 100%;\n    height: 2px;\n    position: absolute;\n    display: block;\n    top: 100%;\n\n    animation: loadingBar 2s linear infinite alternate;\n    background: linear-gradient(\n      90deg,\n      transparent 25%,\n      var(--color-piai-simba) 50%,\n      transparent 75%\n    );\n    background-size: 200% 100%;\n    background-position: 0%;\n  }\n\n  @keyframes loading {\n    0%,\n    100% {\n      opacity: 0.6;\n      transform: scale(0.995);\n    }\n    50% {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n\n  @keyframes loadingBar {\n    0% {\n      opacity: 0.6;\n      background-position: 0%;\n    }\n    100% {\n      opacity: 1;\n      background-position: 100%;\n    }\n  }\n'
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}















// Wrapper + General tool styles
// =================================================
var SimbaWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5e0d61a5-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.applyMixin("uppercase");
}, function(param) {
    var theme = param.theme;
    return theme.color("piaiSimba", 0.8);
});
// Grid and subgrid layouts
// =================================================
var Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5e0d61a5-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.desktop;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.desktop;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.screen;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
});
// Repeating elements
// =================================================
var narrow = (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
// Bigger icon with text on the side
var Blurb = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5e0d61a5-2"
})(_templateObject3(), narrow, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
// Meta columns with icon and narrow text
var Meta = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-5e0d61a5-3"
})(_templateObject4(), function(param) {
    var col = param.col;
    return col > 2 ? 2 : 1;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, function(param) {
    var col = param.col;
    return col;
}, narrow);
var Tags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5e0d61a5-4"
})(_templateObject5());
var Tag = (0,styled_components_browser_esm/* default */.ZP)(Button/* ButtonNormalized */.lr).withConfig({
    componentId: "sc-5e0d61a5-5"
})(_templateObject6(), narrow, function(param) {
    var isActive = param.isActive, theme = param.theme;
    return isActive ? theme.color("piai-simba", 0.4) : "transparent";
}, function(param) {
    var isActive = param.isActive, theme = param.theme;
    return isActive ? "inherit" : "pointer";
});
// Individual elements
// =================================================
var Header = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-5e0d61a5-6"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, narrow);
var BoxHighlight = (0,styled_components_browser_esm/* default */.ZP)(Box/* Box */.x).withConfig({
    componentId: "sc-5e0d61a5-7"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.colors.piaiSimba;
});
var Input = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5e0d61a5-8"
})(_templateObject9());
var Placeholder = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-5e0d61a5-9"
})(_templateObject10());
// END STYLES
// =================================================
var getSummary = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(input) {
        var regex, strippedText, data, response, responseData, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    regex = /(<([^>]+)>)/gi;
                    strippedText = input.replace(regex, " ");
                    data = {
                        text: strippedText,
                        browser_id: "piai-simba_demo"
                    };
                    console.log("data to be sent to API: ", data);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4,
                        fetch("https://simba.publicinterest.ai/simba/api/sum-abstract", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(data)
                        })
                    ];
                case 2:
                    response = _state.sent();
                    if (!(response.status === 200)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    responseData = _state.sent();
                    console.log("API:", responseData);
                    return [
                        2,
                        responseData
                    ];
                case 4:
                    console.error("API Error:", response.status, response.statusText);
                    throw new Error("API Error");
                case 5:
                    return [
                        3,
                        7
                    ];
                case 6:
                    error = _state.sent();
                    console.error("Fetch Error:", error);
                    throw error;
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return function getSummary(input) {
        return _ref.apply(this, arguments);
    };
}();
var Index = function(param) {
    var frontendSettings = param.frontendSettings, tool = param.tool;
    var ref;
    var isTabletAndUp = (0,CssVarsState/* useCssVarsStateIsTabletAndUpState */.kH)();
    var isDesktopAndUp = (0,CssVarsState/* useCssVarsStateIsDesktopAndUpState */._X)();
    var currentTool = (ref = config/* appConfig.tools */.e.tools) === null || ref === void 0 ? void 0 : ref.find(function(t) {
        return t.slug === "simba";
    });
    var ref1 = (0,react.useState)("Newspaper article"), currentExample = ref1[0], setCurrentExample = ref1[1]; // Current selected Tag
    var ref2 = (0,react.useState)(""), currentOutput = ref2[0], setCurrentOutput = ref2[1];
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1]; // True while loading summary
    var ref4 = (0,react.useState)(""), customText = ref4[0], setCustomText = ref4[1]; // State to store textarea value
    var examples = [
        "Newspaper article",
        "Wikipedia page",
        "App description",
        "Custom text", 
    ];
    var renderInput = function() {
        if (currentExample === "Custom text") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                placeholder: "Type text to be highlighted",
                onBlur: handleCustomTextBlur,
                value: customText,
                onChange: function(event) {
                    return setCustomText(event.target.value);
                }
            });
        } else {
            // Render the other input options based on currentExample
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: input.filter(function(e) {
                        return e.example === currentExample;
                    })[0].text
                }
            });
        }
    };
    var renderOutput = function() {
        return loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Placeholder, {
            dangerouslySetInnerHTML: {
                __html: currentOutput
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            dangerouslySetInnerHTML: {
                __html: currentOutput
            }
        });
    };
    (0,react.useEffect)(function() {
        setLoading(false);
        if (currentExample !== "Custom text") {
            setLoading(true);
            setCurrentOutput("Generating the summary for a ".concat(currentExample.toLowerCase(), "…"));
            // getSummary(input.filter((e) => e.example === currentExample)[0].text)
            //   .then((result) => {
            //     setCurrentOutput(result.output);
            //   })
            //   .catch((error) => {
            //     console.error("Error:", error);
            //     setCurrentOutput("Summary can't be generated. We're aplogising for potentially buggy behaviour. Contact us, if this error persists.");
            //   })
            //   .finally(() => {
            //     setLoading(false);
            //   });
            setCurrentOutput(preGeneratedText.filter(function(e) {
                return e.example === currentExample;
            })[0].text);
            setLoading(false);
        } else {
            setCurrentOutput("Insert the text on the left that you want to be summarised.");
        }
    }, [
        currentExample
    ]);
    var handleCustomTextBlur = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var result, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(customText.trim() === "")) return [
                            3,
                            1
                        ];
                        console.log("Textarea is empty…");
                        setCurrentOutput("Insert the text on the left that you want to be summarised.");
                        return [
                            3,
                            6
                        ];
                    case 1:
                        console.log("Textarea is not empty…");
                        setLoading(true);
                        setCurrentOutput("Generating the summary for your custom text…");
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            getSummary(customText)
                        ];
                    case 3:
                        result = _state.sent();
                        setCurrentOutput(result.output);
                        return [
                            3,
                            6
                        ];
                    case 4:
                        error = _state.sent();
                        console.error("Error:", error);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCustomTextBlur() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref5, ref6, ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimbaWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* default */.Z, {
                title: (ref5 = currentTool === null || currentTool === void 0 ? void 0 : currentTool.name) !== null && ref5 !== void 0 ? ref5 : config/* appConfig.appTitle */.e.appTitle,
                description: (ref6 = currentTool === null || currentTool === void 0 ? void 0 : currentTool.description) !== null && ref6 !== void 0 ? ref6 : undefined,
                og: {
                    title: (ref7 = currentTool === null || currentTool === void 0 ? void 0 : currentTool.name) !== null && ref7 !== void 0 ? ref7 : config/* appConfig.appTitle */.e.appTitle,
                    siteName: config/* appConfig.appTitle */.e.appTitle
                },
                twitter: {
                    card: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                children: [
                    isTabletAndUp && /*#__PURE__*/ (0,jsx_runtime.jsx)(LabElement/* LabElement */.c, {
                        shortHandle: tool.iconShort,
                        longText: tool.iconLong,
                        color: "white",
                        hoverColor: tool.colorBase,
                        size: 2
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: "Simba Text assistant"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "The Simba Text Assistant is a browser plug-in that produces summaries of German-language text on web pages."
                            })
                        ]
                    }),
                    isDesktopAndUp && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                type: "info",
                                className: "textLink",
                                spaceBefore: true,
                                url: "/tool/simba/about",
                                "aria-label": "About this tool",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "About"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                type: "repo",
                                className: "textLink",
                                "aria-label": "Go to github repository",
                                url: "https://github.com/fhewett/simba",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "GitHub"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxHighlight, {
                        className: "download firefox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Downnload plugin"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Blurb, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolSvgBackground/* ToolSvgBackground */.V, {
                                        type: "firefox"
                                    }),
                                    "Download Simba as a browser add-on for Firefox and start summarising webpages."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* LinkButtonAnimated */.kz, {
                                href: "https://addons.mozilla.org/en-US/firefox/addon/simba-text-assistant/",
                                target: "_blank",
                                children: "Install Firefox Add-on"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Blurb, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolSvgBackground/* ToolSvgBackground */.V, {
                                        type: "chrome"
                                    }),
                                    "Download Simba as a browser extension from the Chrome web store and start summarising webpages."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* LinkButtonAnimated */.kz, {
                                href: "https://github.com/fhewett/simba/tree/main/highlighter-plugin-chrome",
                                target: "_blank",
                                children: "Install Chrome Extension"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Let us know what you think and help us improve Simba."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                        className: "about",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolSvgBackground/* ToolSvgBackground */.V, {
                                type: "simba",
                                className: "title"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "copy",
                                children: "The Simba Text Assistant is a browser plug-in that produces summaries of German-language text on web pages. It is designed to additionally simplify the summaries, by shortening the sentences and providing explanations for words. We have also integrated the Hurraki dictionary; a Wiki-based dictionary with entries in Leichte Sprache (Easy German Language). You can choose to highlight words found in the dictionary and in the online text, and be shown their definition in Easy Language."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolSvgBackground/* ToolSvgBackground */.V, {
                                type: "screenshot",
                                className: "screenshot"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta, {
                                col: 1,
                                className: "subline",
                                children: "We trained and evaluated the model that provides these simplifications with news articles; that is why it works better for these types of web content. The plug-in also offers the opportunity to submit your feedback on the summary that Simba produces."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                        className: "test",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "intro",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Try it out yourself"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta, {
                                        col: 1,
                                        children: "See for yourself how the model behind Simba works by selecting one of the input sources or by entering your text (coming soon!)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "filter",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Pick an example"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags, {
                                        children: examples.map(function(example, j) {
                                            var isActive = currentExample === example;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                                                onClick: function() {
                                                    if (!isActive) setCurrentExample(example);
                                                },
                                                isActive: isActive,
                                                children: example
                                            }, "tag-filter-".concat(j));
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Input, {
                                className: "input",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Input"
                                    }),
                                    renderInput()
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "output",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Output"
                                    }),
                                    renderOutput()
                                ]
                            }),
                            currentExample == "Custom text" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta, {
                                col: 1,
                                className: "footnote",
                                children: "Please note: our trained Simba model is not yet online – in the meantime we are using a default summarisation model from Huggingface to produce the summaries of these custom texts."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
Index.getLayout = function getLayout(page, props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutTool/* default */.Z, {
        props: props,
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ var simba = (Index);


/***/ }),

/***/ 7568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [471,917,47,774,888,179], function() { return __webpack_exec__(5105); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);